import React, { useContext } from 'react';
import { compact } from 'lodash';
import classNames from 'classnames';
import { routes } from 'constants/config';
import { FilterContext } from 'components/shared/FilterContext/index';
import InsightsTable from '../_shared/InsightsTable';
import SearchTableRow from './SearchTableRow';
import DateRangeFormat from '../_shared/DateRangeFormat';

const TopSearches = ({ i18n, noResults }) => {
  const { params: filterParams } = useContext(FilterContext);
  const title = noResults
    ? i18n.searches.top_null_searches.title
    : i18n.searches.top_searches.title;
  const tableStyles = classNames('TopSearches f-1', { 'mr-32': !noResults });

  return (
    <div className={tableStyles}>
      <InsightsTable
        title={title}
        subtitle={
          filterParams.start_date || filterParams.end_date ? (
            <DateRangeFormat
              start={filterParams.start_date}
              end={filterParams.end_date}
            />
          ) : (
            i18n.timeframes.last_90_days
          )
        }
        i18n={i18n}
        source={compact([
          noResults
            ? routes.INSIGHTS.SEARCH.TOP_NULL_SEARCHES
            : routes.INSIGHTS.SEARCH.TOP_SEARCHES,
          $.param(filterParams),
        ]).join('?')}
        rowComponent={SearchTableRow}
      />
    </div>
  );
};

export default TopSearches;
